module.exports = __webpack_public_path__ + "img/bbb.667aa87d.png";